import {
  IsNumber,
  IsOptional,
  IsString,
  Max,
  Min,
  MinLength,
} from 'class-validator';

export interface SorDto {
  sorId: string;
  entityName?: string;
  entityTypeName?: string;
  sorType?: string;
  isCustom?: boolean;
  providerId?: string;
  eanLocationCode?: string;
  parentSorId?: string;
  institutionOwnerSorId?: string;
  institutionOwnerCvrNumberId?: string;
  postalAddressStreetName?: string;
  postalAddressStreetBuildingId?: string;
  postalAddressDistrictName?: string;
  postalAddressPostCodeId?: string;
  virtualAddressTelephoneNumber?: string;
  virtualAddressFaxNumber?: string;
  virtualAddressEmailAddress?: string;
}

export class SorSearchDto {
  @IsNumber()
  @Min(0)
  skip: number;

  @IsNumber()
  @Min(1)
  @Max(20)
  take: number;

  @IsString()
  @MinLength(1)
  searchText: string;

  /**
   * If set, filters to sor entities that refer to specified sor id
   * When set, also filters to sor entities that have a provider id set
   */
  @IsOptional()
  @IsString()
  filterSorId?: string;
}

/**
 * Query for the admin SOR overview. Unlike {@link SorSearchDto},
 * searchText is optional so the full table can be listed.
 */
export class SorAdminSearchDto {
  @IsNumber()
  @Min(0)
  skip: number;

  @IsNumber()
  @Min(1)
  @Max(50)
  take: number;

  @IsOptional()
  @IsString()
  searchText?: string;
}

/**
 * Payload for manually creating a SOR row for debugging.
 * Only available in non-production environments.
 */
export class CreateCustomSorDto {
  @IsString()
  @MinLength(1)
  sorId: string;

  @IsString()
  @MinLength(1)
  entityName: string;

  @IsOptional()
  @IsString()
  sorType?: string;

  @IsOptional()
  @IsString()
  entityTypeName?: string;

  @IsOptional()
  @IsString()
  providerId?: string;

  @IsOptional()
  @IsString()
  eanLocationCode?: string;

  @IsOptional()
  @IsString()
  parentSorId?: string;

  @IsOptional()
  @IsString()
  institutionOwnerSorId?: string;

  @IsOptional()
  @IsString()
  institutionOwnerCvrNumberId?: string;
}
